import { HeadingWithUnderline } from '@components/ui/heading/HeadingWithUnderline'
import React from 'react'
import { TransitionBtn } from '@components/shared/TransitionBtn'
import styles from './styles.module.css'
import { cloudfrontPath } from '@utils/image'

export const IntroductionCompanies = (): JSX.Element => (
  <section>
    <div className="flex flex-col justify-start w-[87.2vw] lg:w-[65.2vw]">
      <HeadingWithUnderline heading="実施社数800社以上" Tag="h2" />

      <div className="mt-8" style={{ overflow: 'auto' }}>
        <img
          className={styles['company-group-img']}
          src={`${cloudfrontPath}/images/programs/company_group.png`}
          alt="logo"
        />
      </div>

      <div className="flex justify-center items-center mt-8 text-[12px] font-normal text-[#2C2C2C]">
        多くの企業・組合様にてご利用いただいています。
      </div>

      <TransitionBtn text="事例一覧を見る" url="/cases/" />
    </div>
  </section>
)
